.ui.dropdown {
    .text {
      line-height: 1.2;
    }
    .menu .item  {
      line-height: 1.2 !important;
    }
  }
  .ui.selection.dropdown  > .text {
    width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  }
